import React, { useCallback, useMemo } from "react";

import { Company } from "@mapmycustomers/shared/types/entity";

import CreateCompanyModal from "@app/component/createEditEntity/CreateCompanyModal";
import useHiddenChat from "@app/util/useHiddenChat";

import styles from "./Common.module.scss";

const companyFieldNames: (keyof Company)[] = [
  "name",
  "address",
  "city",
  "region",
  "countryCode",
  "postalCode",
  "phone",
  "website",
];

interface Props {}

const CreateCompanyPage: React.FC<Props> = () => {
  const isLeadGen: boolean = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has("mmc_leadgen");
  }, []);

  const initialValues: Partial<Company> = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const latitude = urlParams.has("lat") ? parseFloat(urlParams.get("lat")!) : undefined;
    const longitude = urlParams.has("lng") ? parseFloat(urlParams.get("lng")!) : undefined;
    const hasCoordinates = !(
      latitude === undefined ||
      isNaN(latitude) ||
      longitude === undefined ||
      isNaN(longitude)
    );

    const result: Partial<Company> = {
      geoPoint: hasCoordinates
        ? { coordinates: [longitude!, latitude!], type: "Point" }
        : undefined,
    };

    companyFieldNames.forEach((fieldName) => {
      if (urlParams.has(fieldName)) {
        (result as any)[fieldName] = urlParams.get(fieldName) ?? undefined;
      }
    });

    return result;
  }, []);

  const handleHide = useCallback((newCompany?: Company) => {
    window.parent.postMessage(
      `closeCreateCompanyModal${newCompany ? JSON.stringify(newCompany) : ""}`,
      "*"
    );
  }, []);

  useHiddenChat();

  return (
    <CreateCompanyModal
      className={styles.modalContainer}
      initialValues={initialValues}
      leadGen={isLeadGen}
      onHide={handleHide}
    />
  );
};

export default CreateCompanyPage;
